<template>
  <div class="mobile-container">
    <div class="mobile-header">
      <h1 class="mobile-title">
        <b-icon-person-lines-fill class="title-icon"/>
        Cadastro de Funcionário
      </h1>
      <span class="required-hint">* Campos obrigatórios</span>
    </div>
    
    <div class="tab-content">
      <input hidden v-model="dadosFuncionario.id">
      
      <div class="compact-section">
        <div class="section-header">
          <b-icon-person-fill class="section-icon"/>
          <span>Dados Principais</span>
        </div>
        <div class="form-grid">
          <div class="form-group full-width">
            <input
              class="form-input"
              v-model="dadosFuncionario.nomeFuncionario"
              placeholder=" "
            />
            <label class="form-label">
              Nome Funcionário <span class="required">*</span>
            </label>
          </div>
          
          <div class="form-group">
            <input
              class="form-input"
              v-model="dadosFuncionario.cpf"
              v-mask="maskCpf"
              placeholder=" "
            />
            <label class="form-label">CPF</label>
          </div>
          
          <div class="form-group">
            <input
              class="form-input"
              v-model="dadosFuncionario.rg"
              placeholder=" "
            />
            <label class="form-label">Registro Geral</label>
          </div>
          
          <div class="form-group">
            <input
              type="date"
              class="form-input"
              v-model="dadosFuncionario.dataNascimento"
            />
            <label class="form-label">Data Nascimento</label>
          </div>
        </div>
      </div>

      <div class="compact-section">
        <div class="section-header">
          <b-icon-geo-alt-fill class="section-icon"/>
          <span>Endereço</span>
        </div>
        <div class="form-grid">
          <div class="form-group">
            <input
              class="form-input"
              v-model="dadosFuncionario.cep"
              v-mask="maskCep"
              placeholder=" "
            />
            <label class="form-label">CEP</label>
            <button
              class="action-btn"
              @click="fetchCep(dadosFuncionario.cep)"
            >
              <b-spinner v-if="spinGeneral" small/>
              <span v-else>🔍</span>
            </button>
          </div>
          
          <div class="form-group two-thirds">
            <input
              class="form-input"
              v-model="dadosFuncionario.endereco"
              placeholder=" "
            />
            <label class="form-label">Endereço</label>
          </div>
          
          <div class="form-group one-third">
            <input
              class="form-input"
              v-model="dadosFuncionario.numero"
              placeholder=" "
            />
            <label class="form-label">Número</label>
          </div>
          
          <div class="form-group">
            <input
              class="form-input"
              v-model="dadosFuncionario.bairro"
              placeholder=" "
            />
            <label class="form-label">Bairro</label>
          </div>
          
          <div class="form-group">
            <input
              class="form-input"
              v-model="dadosFuncionario.cidade"
              placeholder=" "
            />
            <label class="form-label">Cidade</label>
          </div>
          
          <div class="form-group select-group">
            <b-form-select
              class="form-select"
              value-field="value"
              text-field="text"
              :options="ufs"
              v-model="dadosFuncionario.uf"
            />
            <label class="select-label">UF</label>
          </div>
        </div>
      </div>

      <div class="compact-section">
        <div class="section-header">
          <b-icon-telephone-fill class="section-icon"/>
          <span>Contato</span>
        </div>
        <div class="form-grid">
          <div class="form-group">
            <input
              class="form-input"
              v-mask="maskTelefone"
              v-model="dadosFuncionario.telefone"
              placeholder=" "
            />
            <label class="form-label">Telefone</label>
          </div>
          
          <div class="form-group">
            <input
              class="form-input"
              v-model="dadosFuncionario.celular"
              v-mask="maskCelular"
              placeholder=" "
            />
            <label class="form-label">Celular</label>
          </div>
          
          <div class="form-group full-width">
            <input
              class="form-input"
              type="email"
              v-model="dadosFuncionario.email"
              placeholder=" "
            />
            <label class="form-label">Email</label>
          </div>
        </div>
      </div>

      <div class="compact-section">
        <div class="section-header">
          <b-icon-info-circle-fill class="section-icon"/>
          <span>Outras Informações</span>
        </div>
        <div class="form-grid">
          <div class="form-group">
            <input
              type="date"
              class="form-input"
              v-model="dadosFuncionario.dataAdimissao"
            />
            <label class="form-label">Data admissão</label>
          </div>
          
          <div class="form-group">
            <input
              class="form-input"
              v-model="dadosFuncionario.funcao"
              placeholder=" "
            />
            <label class="form-label">Função</label>
          </div>
          
          <div class="form-group">
            <input
              class="form-input"
              v-model="dadosFuncionario.carga"
              placeholder=" "
            />
            <label class="form-label">Carga Horária Semanal</label>
          </div>
          
          <div class="form-group">
            <input
              class="form-input"
              v-model="dadosFuncionario.comissao"
              placeholder=" "
            />
            <label class="form-label">Comissão</label>
            <div class="percent-icon">
              <b-icon-percent/>
            </div>
          </div>
          
          <div class="form-group full-width">
            <textarea
              class="form-textarea"
              v-model="dadosFuncionario.observacao"
              placeholder=" "
            />
            <label class="form-label">Observações</label>
          </div>
          
          <div class="form-group select-group">
            <b-form-select
              class="form-select"
              value-field="value"
              text-field="text"
              :options="status"
              v-model="dadosFuncionario.status"
              :disabled="!dadosFuncionario.id"
            />
            <label class="select-label">Status</label>
          </div>
        </div>
      </div>

      <div class="action-buttons">
        <button class="btn-secondary" @click="clear">
          <b-icon-arrow-clockwise/>
          Novo
        </button>
        <button class="btn-primary" @click="saveAndUpdateEmployee">
          <b-icon-check2-circle/>
          {{ dadosFuncionario.id ? "Atualizar" : "Salvar" }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";

import api from "../../services/axios";
import ServiceEmployees from "../../services/serviceEmployees";

import toastAlertErros from "../../utils/toastAlertErros";
import { HandleErrors } from "../../utils/handleErrors";
import { handleCpfOrCnpj } from "../../utils/validateCpfCnpj";
import { ufs } from "../../common/index";

export default {
  props: {
    dataEmployee: {
      type: Object,
    },
    idEmployeeFromSearch: {
      type: String,
      default: "",
    },
  },
  components: {},
  data() {
    return {
      dadosFuncionario: {
        id: "",
        nomeFuncionario: "",
        cpf: "",
        rg: "",
        comissao: "",
        endereco: "",
        numero: "",
        bairro: "",
        cidade: "",
        cep: "",
        uf: "",
        email: "",
        telefone: "",
        celular: "",
        funcao: "",
        carga: "",
        dataAdimissao: "",
        dataNascimento: "",
        observacao: "",
        status: "Ativo",
      },
      status: [
        { value: "Ativo", text: "Ativo" },
        { value: "Inativo", text: "Inativo" },
      ],
      employee: false,
      spinGeneral: false,
      ufs: ufs,
    };
  },
  methods: {
    ...mapMutations([
      "SET_IS_SEARCH_REGISTERS",
      "ALTER_SIZE_MODAL_REGISTER",
      "ALTER_TYPE_REGISTER",
      "SET_COLAPSE_REGISTER",
      "ALTER_MODAL_CONTAINER_REGISTER",
      "SET_DATA_SEARCH_FROM_EMPLOYEE",
    ]),
    clear() {
      this.dadosFuncionario.id = "";
      this.dadosFuncionario.nomeFuncionario = "";
      this.dadosFuncionario.cpf = "";
      this.dadosFuncionario.rg = "";
      this.dadosFuncionario.comissao = "";
      this.dadosFuncionario.endereco = "";
      this.dadosFuncionario.numero = "";
      this.dadosFuncionario.bairro = "";
      this.dadosFuncionario.cidade = "";
      this.dadosFuncionario.cep = "";
      this.dadosFuncionario.uf = "";
      this.dadosFuncionario.email = "";
      this.dadosFuncionario.telefone = "";
      this.dadosFuncionario.celular = "";
      this.dadosFuncionario.observacao = "";
      this.dadosFuncionario.funcao = "";
      this.dadosFuncionario.carga = "";
      this.dadosFuncionario.dataAdimissao = "";
      this.dadosFuncionario.dataNascimento = "";

      this.SET_DATA_SEARCH_FROM_EMPLOYEE({});
    },

    saveAndUpdateEmployee() {
      this.dadosFuncionario.id !== ""
        ? this.updateEmployee()
        : this.saveEmployee();
    },

    async saveEmployee() {
      try {
        const result = handleCpfOrCnpj(this.dadosFuncionario.cpf, this.$toast);
        if (result && !result.isValid) {
          return result.alert();
        }

        const { data } = await api.post("/employees", this.dadosFuncionario);
        this.dadosFuncionario.id = data.id;

        this.$emit("getAllEmployee", this.employee);
        this.employee = !this.employee;
        this.SET_IS_SEARCH_REGISTERS();
        this.clear();
        return this.$toast.open({
          message: "Funcionário salvo com Sucesso",
          type: "success",
        });
      } catch (error) {
        const message = error?.response?.data?.message;

        const typeError = HandleErrors(message);
        if (typeError && Object.keys(typeError).length) {
          return this.$toast.open({
            message: typeError.message,
            type: "info",
          });
        }

        if (message && message.includes("NOT_ALLOWED"))
          this.$toast.open({
            message: message.split(":")[1],
            type: "info",
          });
        else toastAlertErros.validateErroDoesNotContainFor(error, this.$toast);
      }
    },
    async updateEmployee() {
      try {
        const result = handleCpfOrCnpj(this.dadosFuncionario.cpf, this.$toast);
        if (result && !result.isValid) {
          return result.alert();
        }

        await api.put(
          `/employees/${this.dadosFuncionario.id}`,
          this.dadosFuncionario
        );

        this.$emit("getAllEmployee", this.employee);
        this.employee = !this.employee;
        this.SET_IS_SEARCH_REGISTERS();
        this.clear();
        return this.$toast.open({
          message: "Funcionário Atualizado com Sucesso",
          type: "success",
        });
      } catch (error) {
        console.log(error);
        const message = error?.response?.data?.message;

        const typeError = HandleErrors(message);
        if (typeError && Object.keys(typeError).length) {
          return this.$toast.open({
            message: typeError.message,
            type: "info",
          });
        }

        if (message && message.includes("NOT_ALLOWED"))
          this.$toast.open({
            message: message.split(":")[1],
            type: "info",
          });
        else toastAlertErros.validateErroDoesNotContainFor(error, this.$toast);
      }
    },

    async findById(id) {
      const employee = ServiceEmployees.findById(id);
      return employee;
    },

    async handleModalCreateCustomer() {
      const employee = await this.findById(this.idEmployeeFromSearch);
      this.SET_DATA_SEARCH_FROM_EMPLOYEE(employee);
      this.assingEditEmployee();
    },

    assingEditEmployee() {
      this.dadosFuncionario.id = this.dataSearchEmployee.id;
      this.dadosFuncionario.nomeFuncionario =
        this.dataSearchEmployee.nomeFuncionario;
      this.dadosFuncionario.cpf = this.dataSearchEmployee.cpf;
      this.dadosFuncionario.rg = this.dataSearchEmployee.rg;
      this.dadosFuncionario.comissao = this.dataSearchEmployee.comissao;
      this.dadosFuncionario.endereco = this.dataSearchEmployee.endereco;
      this.dadosFuncionario.numero = this.dataSearchEmployee.numero;
      this.dadosFuncionario.bairro = this.dataSearchEmployee.bairro;
      this.dadosFuncionario.cidade = this.dataSearchEmployee.cidade;
      this.dadosFuncionario.cep = this.dataSearchEmployee.cep;
      this.dadosFuncionario.uf = this.dataSearchEmployee.uf;
      this.dadosFuncionario.email = this.dataSearchEmployee.email;
      this.dadosFuncionario.telefone = this.dataSearchEmployee.telefone;
      this.dadosFuncionario.celular = this.dataSearchEmployee.celular;
      this.dadosFuncionario.observacao = this.dataSearchEmployee.observacao;
      this.dadosFuncionario.funcao = this.dataSearchEmployee.funcao;
      this.dadosFuncionario.carga = this.dataSearchEmployee.carga;
      this.dadosFuncionario.status = this.dataSearchEmployee.status;
      this.dadosFuncionario.dataAdimissao =
        this.dataSearchEmployee.dataAdimissao;
      this.dadosFuncionario.dataNascimento =
        this.dataSearchEmployee.dataNascimento;
    },
    async fetchCep(cep) {
      try {
        this.spinGeneral = true;
        const formatedCep = cep.replace(/\D/g, "");
        const data = await api.get(
          `https://brasilapi.com.br/api/cep/v1/${formatedCep}`
        );
        this.dadosFuncionario.endereco = data.data.street;
        this.dadosFuncionario.bairro = data.data.neighborhood;
        this.dadosFuncionario.cidade = data.data.city;
        this.dadosFuncionario.uf = data.data.state;
        this.dadosFuncionario.cep = data.data.cep;
      } catch (error) {
        this.$toast.open({
          message:
            "Ocorreu um erro ao buscar as informações , verifique o CEP e tente novamente",
          type: "info",
        });
      } finally {
        this.spinGeneral = false;
      }
    },
  },
  watch: {
    dataEmployee() {
      Object.assign(this.dadosFuncionario, this.dataEmployee);
    },
  },

  mounted() {
    if (this.dataSearchEmployee.id) {
      this.assingEditEmployee();
    } else if (this.idEmployeeFromSearch) {
      this.handleModalCreateCustomer();
    }
  },
  computed: {
    ...mapState({
      dataSearchEmployee: (state) => state.dataSearchEmployee,
    }),
    maskCpf() {
      return "###.###.###-##";
    },

    maskCelular() {
      return "(##) #####-####";
    },
    maskTelefone() {
      return "(##) ####-####";
    },
    maskCep() {
      return "#####-###";
    },
  },
  beforeDestroy() {
    this.clear();
  },
};
</script>
<style scoped>
.mobile-container {
  padding: 8px;
  max-width: 100vw;
  overflow-x: hidden;
}

.mobile-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  margin-bottom: 12px;
  border-bottom: 2px solid #e8f5e8;
}

.mobile-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 18px;
  font-weight: 700;
  color: #2d5016;
  margin: 0;
}

.title-icon {
  color: #4caf50;
}

.required-hint {
  font-size: 10px;
  color: #f44336;
  font-weight: 500;
}

.tab-content {
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}

.compact-section {
  background: linear-gradient(135deg, #fafafa, #f5f5f5);
  border-radius: 12px;
  padding: 12px;
  margin-bottom: 12px;
  border: 1px solid #e0e0e0;
}

.section-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  padding-bottom: 6px;
  border-bottom: 1px solid #e8e8e8;
}

.section-icon {
  color: #4caf50;
  font-size: 16px;
}

.section-header span {
  font-size: 14px;
  font-weight: 600;
  color: #333;
}

.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

.form-group {
  position: relative;
  min-height: 35px;
}

.form-group.full-width {
  grid-column: 1 / -1;
}

.form-group.two-thirds {
  grid-column: span 1;
  flex: 2;
}

.form-group.one-third {
  grid-column: span 1;
  flex: 1;
}

.form-input, .form-select, .form-textarea {
  width: 100%;
  height: 35px;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 16px;
  background: white;
  transition: all 0.2s ease;
  outline: none;
}

.form-input:focus, .form-select:focus, .form-textarea:focus {
  border-color: #4caf50;
  box-shadow: 0 0 0 2px rgba(76, 175, 80, 0.1);
  transform: translateY(-1px);
}

.form-input.error, .form-select.error {
  border-color: #f44336;
  box-shadow: 0 0 0 2px rgba(244, 67, 54, 0.1);
}

.form-textarea {
  height: 60px;
  resize: vertical;
  min-height: 35px;
}

.form-label, .select-label {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 12px;
  color: #666;
  background: white;
  padding: 0 4px;
  pointer-events: none;
  transition: all 0.2s ease;
  white-space: nowrap;
  z-index: 1;
}

.form-input:focus + .form-label,
.form-input:not(:placeholder-shown) + .form-label,
.form-select:focus + .select-label,
.form-select:not([value=""]) + .select-label {
  top: 0;
  transform: translateY(-50%) scale(0.85);
  color: #4caf50;
  font-weight: 600;
}

.required {
  color: #f44336;
  font-weight: 700;
}

.action-btn {
  position: absolute;
  right: 4px;
  top: 50%;
  transform: translateY(-50%);
  width: 28px;
  height: 28px;
  border: none;
  border-radius: 6px;
  background: linear-gradient(135deg, #4caf50, #66bb6a);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 12px;
}

.action-btn:hover {
  background: linear-gradient(135deg, #43a047, #5cb85c);
  transform: translateY(-50%) scale(1.05);
}

.percent-icon {
  position: absolute;
  right: 4px;
  top: 50%;
  transform: translateY(-50%);
  width: 28px;
  height: 28px;
  background: #25d366;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

.action-buttons {
  display: flex;
  gap: 12px;
  margin: 16px 0;
  padding: 0 4px;
}

.btn-primary, .btn-secondary {
  flex: 1;
  height: 44px;
  padding: 6px;
  border: none;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-primary {
  background: linear-gradient(135deg, #4caf50, #66bb6a);
  color: white;
  box-shadow: 0 2px 8px rgba(76, 175, 80, 0.3);
}

.btn-primary:hover {
  background: linear-gradient(135deg, #43a047, #5cb85c);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.4);
}

.btn-secondary {
  background: linear-gradient(135deg, #f5f5f5, #e0e0e0);
  color: #333;
  border: 1px solid #ddd;
}

.btn-secondary:hover {
  background: linear-gradient(135deg, #eeeeee, #d5d5d5);
  transform: translateY(-1px);
}

.select-group .form-select {
  padding-right: 30px;
}

@media (max-width: 480px) {
  .mobile-container {
    padding: 4px;
  }
  
  .form-grid {
    grid-template-columns: 1fr;
    gap: 6px;
  }
  
  .form-group.two-thirds,
  .form-group.one-third {
    grid-column: 1;
  }
  
  .mobile-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
  
  .action-buttons {
    flex-direction: column;
  }
}

@media (min-width: 768px) {
  .form-grid {
    grid-template-columns: 1fr 1fr 1fr;
  }
  
  .mobile-container {
    max-width: 800px;
    margin: 0 auto;
    padding: 16px;
  }
}

.text-center { text-align: center; }
.text-right { text-align: right; }
.mb-0 { margin-bottom: 0; }
.mt-0 { margin-top: 0; }

.form-input:disabled,
.form-select:disabled {
  background-color: #f5f5f5;
  cursor: not-allowed;
  opacity: 0.7;
}

*:focus {
  outline: none;
}

.form-input:focus,
.form-select:focus,
.btn-primary:focus,
.btn-secondary:focus {
  outline: 2px solid #4caf50;
  outline-offset: 2px;
}
</style>
